import { useStaticQuery, graphql } from "gatsby"

export const useFooter = () => {
  const data = useStaticQuery(
    graphql`
      query {
        graphqlData {
          menuByName(name: "footer") {
            links {
              url {
                path
              }
              label
            }
          }
        }
      }
    `
  )
  return data
}
